// extracted by css-extract-rspack-plugin
export default {"destinationLink":"JBHDP"};